<iframe [src]="sanitizedTrackingUrl" allowTransparency="true" frameborder="0"
        class="bg-surface" style="width: 100%; height: 100vh;">
</iframe>
